import { render, staticRenderFns } from "./DataAccessSubscriptionCheckPage.vue?vue&type=template&id=488a6b9a&scoped=true&"
import script from "./DataAccessSubscriptionCheckPage.vue?vue&type=script&lang=ts&"
export * from "./DataAccessSubscriptionCheckPage.vue?vue&type=script&lang=ts&"
import style0 from "./DataAccessSubscriptionCheckPage.vue?vue&type=style&index=0&id=488a6b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488a6b9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('488a6b9a')) {
      api.createRecord('488a6b9a', component.options)
    } else {
      api.reload('488a6b9a', component.options)
    }
    module.hot.accept("./DataAccessSubscriptionCheckPage.vue?vue&type=template&id=488a6b9a&scoped=true&", function () {
      api.rerender('488a6b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/DataAccessSubscriptionCheckPage.vue"
export default component.exports